@if(show){
<div class="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center">
  <div class="bg-white rounded-xl shadow-lg w-full md:w-1/2">
    <div class="flex items-center justify-center font-bold text-2xl h-16 border border-b-indigo-700 bg-[#00297A] text-white">
      <h2 class="text-[14px] font-semibold">{{buttonInfo}} Dependent</h2>
    </div>
    <form [formGroup]="childForm" (ngSubmit)="onSubmit()">
      <div class="grid grid-cols-1 sm:grid-cols-6 gap-3 p-2" style="padding: 38px; column-gap: 12px;">

        @for (fieldKey of childFieldKeys; track fieldKey) {
          @if (isChildFieldVisible(childFieldsConfig[fieldKey])) {

            <!-- text -->
            @if (childFieldsConfig[fieldKey].type === 'text') {
              <div [ngClass]="childFieldsConfig[fieldKey].customClass?.all || 'sm:col-span-3'">
                <label [for]="childFieldsConfig[fieldKey].control_name" class="labeling">
                  {{ lang[childFieldsConfig[fieldKey].language_token] || childFieldsConfig[fieldKey].label }}
                  @if (childFieldsConfig[fieldKey].required?.length) {<span class="text-danger">*</span>}
                </label>
                <input class="form-control checking-field" type="text"
                  [placeholder]="childFieldsConfig[fieldKey].placeholder || ''"
                  [id]="childFieldsConfig[fieldKey].control_name"
                  [formControlName]="childFieldsConfig[fieldKey].control_name"
                  (keypress)="alphabatesOnly($event)" />
                @if (childForm.get(childFieldsConfig[fieldKey].control_name)?.errors && childForm.get(childFieldsConfig[fieldKey].control_name)?.touched) {
                  <div class="invalid text-red-500">
                    @if (childForm.get(childFieldsConfig[fieldKey].control_name)?.errors?.['required']) {
                      <div>{{ lang[childFieldsConfig[fieldKey].error] || childFieldsConfig[fieldKey].error }}</div>
                    }
                  </div>
                }
              </div>
            }

            <!-- dropdown -->
            @if (childFieldsConfig[fieldKey].type === 'dropdown') {
              <div [ngClass]="childFieldsConfig[fieldKey].customClass?.all || 'sm:col-span-3'">
                <label [for]="childFieldsConfig[fieldKey].control_name" class="labeling">
                  {{ lang[childFieldsConfig[fieldKey].language_token] || childFieldsConfig[fieldKey].label }}
                  @if (childFieldsConfig[fieldKey].required?.length) {<span class="text-danger">*</span>}
                </label>
                <select class="form-control"
                  [formControlName]="childFieldsConfig[fieldKey].control_name"
                  [id]="childFieldsConfig[fieldKey].control_name">
                  <option value="" selected disabled>{{ lang.Select }}</option>
                  @for (opt of childFieldsConfig[fieldKey].options; track opt.value) {
                    <option [value]="opt.value">{{ lang[opt.label] || opt.label }}</option>
                  }
                </select>
                @if (childForm.get(childFieldsConfig[fieldKey].control_name)?.errors && childForm.get(childFieldsConfig[fieldKey].control_name)?.touched) {
                  <div class="invalid text-red-500">
                    @if (childForm.get(childFieldsConfig[fieldKey].control_name)?.errors?.['required']) {
                      <div>{{ lang[childFieldsConfig[fieldKey].error] || childFieldsConfig[fieldKey].error }}</div>
                    }
                  </div>
                }
              </div>
            }

            <!-- datepicker -->
            @if (childFieldsConfig[fieldKey].type === 'datepciker') {
              <div [ngClass]="childFieldsConfig[fieldKey].customClass?.all || 'sm:col-span-3'">
                <label [for]="childFieldsConfig[fieldKey].control_name" class="labeling">
                  {{ lang[childFieldsConfig[fieldKey].language_token] || childFieldsConfig[fieldKey].label }}
                  @if (childFieldsConfig[fieldKey].required?.length) {<span class="text-danger">*</span>}
                </label>
                <input type="text" (paste)="(false)" class="form-control"
                  [formControlName]="childFieldsConfig[fieldKey].control_name"
                  [id]="childFieldsConfig[fieldKey].control_name"
                  [minDate]="minDate" [maxDate]="maxDate" bsDatepicker
                  [bsConfig]="{dateInputFormat: 'MM-DD-YYYY', showWeekNumbers: false}"
                  placeholder="MM-DD-YYYY"
                  (blur)="checkChildDateofBirth($event)"
                  (input)="checkChildDateofBirth($event)"
                  (keypress)="numbersOnly($event)" />
                @if (childForm.get(childFieldsConfig[fieldKey].control_name)?.errors && childForm.get(childFieldsConfig[fieldKey].control_name)?.touched) {
                  <div class="invalid text-red-500">
                    @if (childForm.get(childFieldsConfig[fieldKey].control_name)?.errors?.['required']) {
                      <div>{{ lang[childFieldsConfig[fieldKey].error] || childFieldsConfig[fieldKey].error }}</div>
                    }
                    @if (childForm.get(childFieldsConfig[fieldKey].control_name)?.errors?.['childrenminimumAge']) {
                      <div>Age must be below {{childForm.get(childFieldsConfig[fieldKey].control_name)?.errors?.['childrenminimumAge']['maxAge']}} years</div>
                    }
                    @if (childForm.get(childFieldsConfig[fieldKey].control_name)?.errors?.['validGraduationDateBirth']) {
                      <div>{{lang.Please_ensure_the_graduation_date_is_greater_than_the_date_of_birth}}</div>
                    }
                  </div>
                }
              </div>
            }

            <!-- radio -->
            @if (childFieldsConfig[fieldKey].type === 'radio') {
              <div [ngClass]="childFieldsConfig[fieldKey].customClass?.all || 'col-span-full'">
                <label class="labeling">
                  {{ lang[childFieldsConfig[fieldKey].language_token] || childFieldsConfig[fieldKey].label }}
                  @if (childFieldsConfig[fieldKey].required?.length) {<span class="text-danger">*</span>}
                </label>
                <div class="flex flex-row gap-6 flex-wrap">
                @for (opt of childFieldsConfig[fieldKey].options; track opt.value) {
                  <div class="flex items-center space-x-2">
                    <input type="radio"
                      [id]="childFieldsConfig[fieldKey].control_name + '_' + opt.value"
                      [formControlName]="childFieldsConfig[fieldKey].control_name"
                      [value]="opt.value"
                      (click)="onRadioChange(childFieldsConfig[fieldKey].control_name, $event)"
                      class="form-radio text-blue-600" />
                    <label [for]="childFieldsConfig[fieldKey].control_name + '_' + opt.value" class="labeling">
                      {{ lang[opt.label] || opt.label }}
                    </label>
                  </div>
                }
                </div>
                @if (childForm.get(childFieldsConfig[fieldKey].control_name)?.errors && childForm.get(childFieldsConfig[fieldKey].control_name)?.touched) {
                  <div class="invalid text-red-500">
                    @if (childForm.get(childFieldsConfig[fieldKey].control_name)?.errors?.['required']) {
                      <div>{{ lang[childFieldsConfig[fieldKey].error] || childFieldsConfig[fieldKey].error }}</div>
                    }
                  </div>
                }
              </div>
            }

            <!-- checkbox -->
            @if (childFieldsConfig[fieldKey].type === 'checkbox') {
              <div [ngClass]="childFieldsConfig[fieldKey].customClass?.all || 'sm:col-span-full'">

                <!-- For Post-Secondary Student: checkbox on top, graduation date below when checked -->
                @if (childFieldsConfig[fieldKey].control_name === 'enrolledInUniversity') {
                  <div>

                    <!-- Checkbox + label -->
                    <div class="flex items-center gap-2">
                      <input type="checkbox" style="flex-shrink:0; margin:0;"
                        [id]="childFieldsConfig[fieldKey].control_name"
                        [formControlName]="childFieldsConfig[fieldKey].control_name"
                        (change)="onCheckboxChange(childFieldsConfig[fieldKey].control_name, $event)" />
                      <label [for]="childFieldsConfig[fieldKey].control_name" class="labeling" style="margin:0; line-height:1.4; cursor:pointer;">
                        {{ lang[childFieldsConfig[fieldKey].language_token] || childFieldsConfig[fieldKey].label }}
                      </label>
                    </div>

                    <!-- Graduation date — only when checked -->
                    @if (childForm.get('enrolledInUniversity')?.value) {
                      <div class="mt-2" style="max-width:50%; padding-left:16px">
                        <label class="labeling" for="graduationDay">
                          {{ lang.Graduation_Date || 'Graduation Date' }}<span class="text-danger">*</span>
                        </label>
                        <input type="text" class="form-control" (paste)="(false)" id="graduationDay"
                          bsDatepicker placeholder="MM-DD-YYYY"
                          [bsConfig]="{dateInputFormat: 'MM-DD-YYYY', showWeekNumbers: false}"
                          (blur)="checkDateOfgraducation($event)"
                          (input)="checkDateOfgraducation($event)"
                          (keypress)="numbersOnly($event)"
                          [placement]="'top'"
                          formControlName="graduationDay" />
                        @if (f['graduationDay'] && f['graduationDay'].errors && f['graduationDay'].touched) {
                          <div class="invalid text-red-500">
                            @if (f['graduationDay'].errors['required']) {
                              <div>{{lang.Please_choose_graduation_date}}</div>
                            }
                            @if (f['graduationDay'].errors['validGraduationDate']) {
                              <div>{{lang.Please_ensure_the_graduation_date_is_greater_than_the_date_of_birth}}</div>
                            }
                            @if (f['graduationDay'].errors['dateOfBirth']) {
                              <div>{{lang.Select_Date_of_birth}}</div>
                            }
                          </div>
                        }
                      </div>
                    }

                  </div>

                  <!-- "Indicate post secondary student" hint below -->
                  @if (childForm.get('date_of_birth')?.errors?.['childrenminimumAge']) {
                    <div style="font-style: italic;" class="mt-1">
                      Indicate post secondary student
                    </div>
                  }
                }

                <!-- All other checkboxes -->
                @if (childFieldsConfig[fieldKey].control_name !== 'enrolledInUniversity') {
                  <div class="flex items-center gap-2">
                    <input type="checkbox" style="flex-shrink:0; margin:0;"
                      [id]="childFieldsConfig[fieldKey].control_name"
                      [formControlName]="childFieldsConfig[fieldKey].control_name"
                      (change)="onCheckboxChange(childFieldsConfig[fieldKey].control_name, $event)" />
                    <label [for]="childFieldsConfig[fieldKey].control_name" class="labeling" style="margin:0; line-height:1.4; cursor:pointer;">
                      {{ lang[childFieldsConfig[fieldKey].language_token] || childFieldsConfig[fieldKey].label }}
                    </label>
                  </div>
                }

              </div>
            }


          }
        }



       


      </div>

      <div class="flex justify-end gap-2 border border-t-indigo-700 px-2">
        <button type="button"
          class="w-36 h-14 mt-2 mb-2 rounded-full border-2 border-indigo-200 bg-indigo-200 p-0.5 font-bold hover:bg-white"
          (click)="onClose()">
          {{ lang.Cancel }}
        </button>
        <button type="submit"
          class="w-36 h-14 mt-2 mb-2 rounded-full border-2 border-indigo-700 p-0.5 font-bold hover:border-green-500"
          [disabled]="childForm.invalid">
          {{buttonInfo}}
        </button>
      </div>
    </form>
  </div>
</div>
}
